import ApiService from '@/helpers/api.service';
import { Storage } from 'aws-amplify';
import moment from "moment";

const API = new ApiService();

// Endpoints
const BUSS_CATEGORY_ENDPOINT = '/product-template/category';
const PROD_TEMPLATE_ENPOINT = '/product-template/product';
const PROD_GROUP_ENDPOINT = '/product-template/group';
const PROD_BRAND_ENDPOINT = '/product-template/brand';

export const state = {
  businessCategories: [],
  businessCategoriesPage: {
    totalRows: 0,
    totalPage: 0
  },
  productGroups: [],
  productGroupsPage: {
    totalRows: 0,
    totalPage: 0
  },
  productTemplates: [],
  productTemplatesPage: {
    totalRows: 0,
    totalPage: 0
  },
  productBrands: [],
  productBrandsPage: {
    totalRows: 0,
    totalPage: 0
  },
  unitOfMeasurementList: [],
  productSuggestionList: [],
  productSuggestionsCount: 0,
  errors: null
}

export const mutations = {
  UPDATE_BUSS_CATEGORY_LIST(state, categories){
    state.businessCategories = categories;
  },
  UPDATE_BUSS_CATEGORY_PAGE(state, pageInfo){
    state.businessCategoriesPage = pageInfo;
  },
  UPDATE_PROD_GROUP_LIST(state, groups){
    state.productGroups = groups;
  },
  UPDATE_PROD_GROUP_PAGE(state, pageInfo){
    state.productGroupsPage = pageInfo;
  },
  UPDATE_PROD_TEMPLATE_LIST(state, productTemplates){
    state.productTemplates = productTemplates;
  },
  UPDATE_PROD_TEMPLATE_PAGE(state, pageInfo){
    state.productTemplatesPage = pageInfo;
  },
  UPDATE_PROD_BRAND_LIST(state, brand){
    state.productBrands = brand;
  },
  UPDATE_PROD_BRAND_PAGE(state, pageInfo){
    state.productBrandsPage = pageInfo;
  },
  SET_PROD_ERRORS(state, errors){
    state.errors = errors;
  },
  UPDATE_UOM_LIST(state, uomList){
    state.unitOfMeasurementList = uomList;
  },
  UPDATE_PROD_SUGGESTION_LIST(state, list){
    state.productSuggestionList = list;
  },
  UPDATE_PROD_SUGGESTION_COUNT(state, count){
    state.productSuggestionsCount = count;
  },
}

export const actions = {
  // Business category actions
  listBusinessCategories(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSS_CATEGORY_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_BUSS_CATEGORY_LIST', data.message.rows);
            context.commit('UPDATE_BUSS_CATEGORY_PAGE', {
              totalRows: data.message.pageInfo.total,
              totalPage: data.message.pageInfo.noOfPage
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createBusinessCategory(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSS_CATEGORY_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  updateBusinessCategory(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${BUSS_CATEGORY_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data.message);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteBusinessCategory(context, productId){
    return new Promise((resolve, reject) => {
      var params = { productId: productId };
      API.post(`${BUSS_CATEGORY_ENDPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // End business category actions

  // Product templates actions
  listProductTemplates(context,params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_PROD_TEMPLATE_LIST', data.message.rows);
            context.commit('UPDATE_PROD_TEMPLATE_PAGE', {
              totalRows: data.message.pageInfo.total,
              totalPage: data.message.pageInfo.noOfPage
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createProductTemplate(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject(response);
        });
    });
  },
  updateProductTemplate(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteProductTemplate(context, id){
    return new Promise((resolve, reject) => {
      var params = { id: id };
      API.post(`${PROD_TEMPLATE_ENPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  getProductTemplate(context, id){
    return new Promise((resolve, reject) => {
      var params = { id: id };
      API.post(`${PROD_TEMPLATE_ENPOINT}/info`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve(data.message);
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  setProductSuggestionList(context, list) {
    return new Promise((resolve) => {
      context.commit('UPDATE_PROD_SUGGESTION_LIST', list);
      context.commit('UPDATE_PROD_SUGGESTION_COUNT', list.length);
      resolve();
    })
  },
  bulkCreateProductTemplate(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/bulk-insert`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve(data);
          }
        })
        .catch(({ response }) => {
            context.commit('SET_PROD_ERRORS', response.data.errors);
            reject(response);
        });
    });
  },
  // End product templates actions

  // Product groups actions
  listProductGroups(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_GROUP_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_PROD_GROUP_LIST', data.message.rows);
            context.commit('UPDATE_PROD_GROUP_PAGE', {
              totalRows: data.message.pageInfo.total,
              totalPage: data.message.pageInfo.noOfPage
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createProductGroup(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_GROUP_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  updateProductGroup(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_GROUP_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteProductGroup(context, id){
    return new Promise((resolve, reject) => {
      var params = { id: id };
      console.log("Deleting");
      API.post(`${PROD_GROUP_ENDPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // End product groups actions

  // Product brand actions
  listProductBrands(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_BRAND_ENDPOINT}/list`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_PROD_BRAND_LIST', data.message.rows);
            context.commit('UPDATE_PROD_BRAND_PAGE', {
                totalRows: data.message.pageInfo.total,
                totalPage: data.message.pageInfo.noOfPage
            });
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  createProductBrand(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_BRAND_ENDPOINT}/create`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  updateProductBrand(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_BRAND_ENDPOINT}/update`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject(data);
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  deleteProductBrand(context, id){
    return new Promise((resolve, reject) => {
      console.log("deleteProductBrand: " + id);
      var params = { id: id };
      API.post(`${PROD_BRAND_ENDPOINT}/delete`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  // End Product brand actions
  
  // Logo upload
  uploadLogo(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png","svg"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      var metadata =  {
        customPrefix: {
          public: ''
        },
        expires: moment().add(30, 'days').toDate(),
      }

      if(params.type == 'svg'){
        metadata['contentType'] = 'image/svg+xml';
      }
      Storage.put(`${params.folder}/${params.filename}`, params.base64, metadata)
        .then(stored => {
            console.log(stored);
            resolve(stored.key);
        })
        .catch(err => {
            console.log(err);
            reject(err);
        });
    });
  },

  //unit of measurements
  getUnitOfMeasureList(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/get-uom`, params)
        .then(({ data }) => {
          if(data.status == "err"){
            reject();
          } else {
            context.commit('UPDATE_UOM_LIST', data.message);
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  newUnitOfMeasure(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/new-uom`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
  delUnitOfMeasure(context, params){
    return new Promise((resolve, reject) => {
      API.post(`${PROD_TEMPLATE_ENPOINT}/delete-uom`, params)
        .then(({data}) => {
          if(data.status == "err"){
            reject();
          } else {
            resolve();
          }
        })
        .catch(({ response }) => {
          context.commit('SET_PROD_ERRORS', response.data.errors);
          reject();
        });
    });
  },
}

export const getters = {
  
}